import React, { Component } from "react";
import { Alert, message, notification, List, Card, Select, Radio, Layout, Input, Button, Col, InputNumber, Popconfirm, Form, Icon, Table, Divider, DatePicker } from "antd";


import "../App.css";
import {
  BrowserRouter as Router,
  Route,
  Link,
  Redirect,
  withRouter
} from 'react-router-dom'
import moment from 'moment';
import Papa from 'papaparse';
// We import our firestore module
import { db } from '../firebase/firebase';



const InputGroup = Input.Group;

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

const { Column } = Table;
const Option = Select.Option;

const key = 'updatable';








const data = [

  {
    title: 'Note',
    content: 'units: 12 keys + 1 id = 13 TOTAL FIELDS all string.'
  },
  {
    title: 'Others',
    content: ''
  },
];
const success = (x) => {
  message.success(x);
};

const error = () => {
  message.error('This is a message of error');
};

const warning = () => {
  message.warning('This is message of warning');
};
const load = (x) => {
  message.loading(x);
}

const Option2 = Select.Option;

const FormItem = Form.Item;
const EditableContext = React.createContext();

const EditableRow = ({ form, index, ...props }) => (
  <EditableContext.Provider value={form}>
    <tr {...props} />
  </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);

class EditableCell extends React.Component {
  getInput = () => {
    // if (this.props.inputType === 'number') {
    //   return <InputNumber />;
    // }
    return <Input />;
  };

  render() {
    const {
      editing,
      dataIndex,
      title,
      inputType,
      record,
      index,
      ...restProps
    } = this.props;
    return (
      <EditableContext.Consumer>
        {(form) => {
          const { getFieldDecorator } = form;
          return (
            <td {...restProps}>
              {editing ? (
                <FormItem style={{ margin: 0 }}>
                  {getFieldDecorator(dataIndex, {
                    rules: [{
                      required: false,
                      message: `Please Input ${title}!`,
                    }],
                    initialValue: record[dataIndex],
                  })(this.getInput())}
                </FormItem>
              ) : restProps.children}
            </td>
          );
        }}
      </EditableContext.Consumer>
    );
  }
}
export class AdminUnits extends Component {
  constructor(props) {
    super(props);
    this.state = {
      msglist: [],
      count: 0,
      searchText: '',
      data: [],
      major: [],
      editingKey: '',
      tempStatus: '',
      ta: null,
      xa: null,
      ya: null,
      sa: null,
      ca: null
    };
    this.columns = [
      {
        title: '',
        dataIndex: 'operation',
        // fixed: 'left',
        render: (text, record) => {
          const editable = this.isEditing(record);
          return (
            <div>
              {editable ? (
                <span>
                  <EditableContext.Consumer>
                    {form => (
                      <a
                        href="javascript:;"
                        onClick={() => this.save(form, record.key)}
                        style={{ marginRight: 8 }}
                      >
                        Save
                      </a>
                    )}
                  </EditableContext.Consumer>
                  <a
                    href="javascript:;"
                    style={{ marginRight: 8 }}
                    onClick={() => this.cancel(record.key)}
                  >
                    Cancel
                  </a>
                </span>
              ) : (
                  <div>
                    <Button
                      onClick={() => this.edit(record.key)}
                      className="App-t"
                    >
                      Edit
                </Button>
                    {/* THIS IS THE DELETE BUTTON (TURNED OFF BY REQUEST) */}
                    {/* <Divider type="vertical" />
                    <Popconfirm
                      title="Confirm Delete?"
                      onConfirm={evt => this.deleteProject(record.key)}
                    >
                      <Button>Delete</Button>
                    </Popconfirm> */}

                  </div>
                )}
            </div>
          );
        },
      },
      {
        title: '',
        dataIndex: 'key',
        ...this.getColumnSearchProps('key'),
        editable: false,
      },
      {
        title: 'doc_id',
        dataIndex: 'id',
        ...this.getColumnSearchProps('id'),
        editable: false,
      },
      {
        title: 'projects',
        dataIndex: 'projects',
        ...this.getColumnSearchProps('projects'),
        editable: true,
      },
      {
        title: 'unittype',
        dataIndex: 'unittype',
        ...this.getColumnSearchProps('unittype'),
        editable: true,
        sorter: (a, b) => { return a.unittype.localeCompare(b.unittype) },
      },
      {
        title: 'lot',
        dataIndex: 'lot',
        ...this.getColumnSearchProps('lot'),
        editable: true,
        sorter: (a, b) => { return a.lot.localeCompare(b.lot) },
      },
      {
        title: 'unitno',
        dataIndex: 'unitno',
        ...this.getColumnSearchProps('unitno'),
        editable: true,
        sorter: (a, b) => { return a.unitno.localeCompare(b.unitno) },
      },
      {
        title: 'size',
        dataIndex: 'size',
        ...this.getColumnSearchProps('size'),
        editable: true,
        sorter: (a, b) => parseInt(a.size, 10) - parseInt(b.size, 10),
        onHeaderCell: (column) => {
          return {
            onClick: () => {
              console.log('onClick');
            }
          };
        }
      },
      {
        title: 'price',
        dataIndex: 'price',
        ...this.getColumnSearchProps('price'),
        editable: true,
        sorter: (a, b) => parseInt(a.price, 10) - parseInt(b.price, 10),
      },
      {
        title: 'customer',
        dataIndex: 'customer',
        ...this.getColumnSearchProps('customer'),
        editable: true,
        sorter: (a, b) => a.customer.length - b.customer.length,
      },
      {
        title: 'yy',
        dataIndex: 'yy',
        ...this.getColumnSearchProps('yy'),
        editable: true,
        sorter: (a, b) => a.yy.length - b.yy.length,
      },
      {
        title: 'xx',
        dataIndex: 'xx',
        ...this.getColumnSearchProps('xx'),
        editable: true,
        sorter: (a, b) => a.xx.length - b.xx.length,
      },
      {
        title: 'date',
        dataIndex: 'date',
        ...this.getColumnSearchProps('date'),
        editable: true,
        sorter: (a, b) => a.date.length - b.date.length,
      },
      {
        title: 'isSold',
        dataIndex: 'isSold',
        width: '10%',
        filters: [{
          text: 'Sold',
          value: 'Sold',
        }, {
          text: 'Open',
          value: 'Open',
        }],
        filterMultiple: false,
        onFilter: (value, record) => record.isSold.indexOf(value) === 0,
        render: (text, record) => {
          const editable = this.isEditing(record);

          return (
            <div>
              {editable ? (
                <div>
                  <Select style={{ width: 120 }} defaultValue={this.state.data[record.key].isSold} onChange={(value) => this.selector(record.key, value)}>
                    <Option2 value="Open">Open</Option2>
                    <Option2 value="Sold">Sold</Option2>
                  </Select>
                </div>
              ) : (
                  <div>
                    {this.state.data[record.key].isSold}
                  </div>
                )}
            </div>
          );
        },
      },

    ];

    // this.loadtheresult = this.loadtheresult.bind(this);
    this.addProject = this.addProject.bind(this);
    this.deleteProject = this.deleteProject.bind(this);
    this.pullFromDB();
  }

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys, selectedKeys, confirm, clearFilters,
    }) => (
        <div style={{ padding: 8 }}>
          <Input
            ref={node => { this.searchInput = node; }}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm)}
            icon="search"
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
        </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
        </Button>
        </div>
      ),
    filterIcon: filtered => <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => (
      text
    ),
  })

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  }

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: '' });
  }



  exportFile = () => {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      error('This feature is only on PC.')
    } else {
      this.state.major = [];
      var i;
      for (i = 0; i < this.state.data.length; i++) {
        var lol = [
          this.state.data[i].id,
          this.state.data[i].projects,
          this.state.data[i].unittype,
          this.state.data[i].lot,
          this.state.data[i].unitno,
          this.state.data[i].size,
          this.state.data[i].price,
          this.state.data[i].customer,
          this.state.data[i].yy,
          this.state.data[i].xx,
          this.state.data[i].date,
          this.state.data[i].isSold
        ];
        this.state.major.push(lol)
      }

      // console.log(this.state.major)
      // alert("the string: " + this.state.major.toString())
      success(this.state.major.length + " records ready to download")
      if (this.state.major.length > 1)
        this.downloadcsv();
    }
  }

  downloadcsv = (e) => {
    // console.log("heyy2 " + this.state.major);
    var csv = `doc_id,projects,unittype,lot,unitno,size,price,customer,yy,xx,date,isSold,\n`

    this.state.major.forEach(function (row) {
      csv += row.join(',');
      csv += "\n";
    });

    var hiddenElement = document.createElement('a');
    hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
    hiddenElement.target = '_blank';
    hiddenElement.download = 'units.csv';
    hiddenElement.click();
  }

  loadtheresult = (file) => {
    Papa.parse(file, {
      header: true,
      complete: function (results) {
        var a = results.data
        console.log("Finished:", a);

        (async function loop() {
          for (let i = 0; i < a.length; i++) {
            if (a[i].doc_id.length > 0) {
              let bb = i + 1
              let cc = a.length - 1

              notification.open({
                key,
                message: 'Importing...',
                description: 'setting ' + bb + '/' + cc,
              });

              await new Promise((resolve, reject) => {
                console.log('processing ' + a[i].doc_id)
                db.collection('units').doc(a[i].doc_id).set({
                  projects: a[i].projects,
                  unittype: a[i].unittype,
                  lot: a[i].lot,
                  unitno: a[i].unitno,
                  size: a[i].size,
                  price: a[i].price,
                  customer: a[i].customer,
                  yy: a[i].yy,
                  xx: a[i].xx,
                  date: a[i].date,
                  isSold: a[i].isSold,
                }, { merge: true }).then(resolve).catch((err) => {
                  message.error('Error getting documents' + err.message);
                });
              });

            }
          }
          notification.destroy()
          message.success("Uploaded successfully")
        })();



        // try {
        //   var ss = await db.collection('units').doc(a[i].doc_id)
        //   ss.set({
        //     key: '42'
        //   }, { merge: true });
        //   console.log("end")
        // }
        // catch (err) {
        //   console.log('Error getting documents', err);
        // }




      }
    });
  }

  handlefile = (event) => {
    if (event.target.files[0]) {
      console.log('Parameter' + event.target.files[0].type);
      if (true) {
        console.log("accepted file format")
        if (event.target.files[0].size < 100000000) {
          console.log(event.target.files[0])
          var file = event.target.files[0];
          this.loadtheresult(file);
        } else {
          message.error("File is too big!");
        }
      } else {
        message.error("Not the accepted file type!");
      }
    } else {
      message.error("No file in it!");
    }
  }


  alerty = (msg) => {
    let a = <Alert message={msg} type="error" />
    let arr = [...this.state.msglist]
    arr.push(a)
    this.setState({ msglist: arr })
  }
  pullFromDB() {
    // We listen for live changes to our data collection in Firebase
    db.collection("units").onSnapshot(snapshot => {
      //data is locally available array, pulled from firestore.
      let data = [];

      let arr = []
      this.setState({ msglist: arr })

      snapshot.forEach(doc => {
        const todo = doc.data();
        todo.id = doc.id;
        data.push(todo);

        if (typeof todo.projects === 'undefined' || todo.projects == '' || typeof todo.projects !== 'string' )
          this.alerty('undefined projects ' + todo.id)
        if (typeof todo.unittype === 'undefined' || todo.unittype == '' || typeof todo.unittype !== 'string' )
          this.alerty('undefined unittype ' + todo.id)
        if (typeof todo.lot === 'undefined' || todo.lot == '' || typeof todo.lot !== 'string' )
          this.alerty('undefined lot ' + todo.id)
        if (typeof todo.unitno === 'undefined' || todo.unitno == '' || typeof todo.unitno !== 'string' )
          this.alerty('undefined unitno ' + todo.id)
        if (typeof todo.size === 'undefined' || todo.size == '' || typeof todo.size !== 'string' )
          this.alerty('undefined size ' + todo.id)
        if (typeof todo.price === 'undefined')
          this.alerty('undefined price ' + todo.id)
        if (typeof todo.customer === 'undefined')
          this.alerty('undefined customer ' + todo.id)
        if (typeof todo.yy === 'undefined' || todo.yy == '' || typeof todo.yy !== 'string' )
          this.alerty('undefined yy ' + todo.id)
        if (typeof todo.xx === 'undefined' || todo.xx == '' || typeof todo.xx !== 'string' )
          this.alerty('undefined xx ' + todo.id)
        if (typeof todo.date === 'undefined')
          this.alerty('undefined date ' + todo.id)
        if (typeof todo.isSold === 'undefined' || todo.isSold == '' || typeof todo.isSold !== 'string' )
          this.alerty('undefined isSold ' + todo.id)
      });

      // Sort our data based on time added
      data.sort(function (a, b) {
        return (
          new Date(b.date).getTime() - new Date(a.date).getTime()
        );
      });

      //assign primary key
      for (var i = 0; i < data.length; i++) {
        data[i].key = i;
      }



      // Anytime the state of our database changes, we update state
      this.setState({ data, count: data.length });

    })
  }



  selector(key, value) {
    // this.state.data[key].isSold = value;
    this.setState({ tempStatus: value });
  }

  async deleteProject(id) {
    // alert("record.key: " + id + "todo id: " + this.state.data[id].id)
    await db
      .collection("units")
      .doc(this.state.data[id].id)
      .delete();
  }



  async addProject() {
    var na = moment()
    var bb = await db.collection("units").add({
      date: na.toISOString(),
      unittype: "ba",
      projects: this.props.match.params.id,
      lot: "test",
      unitno: "test",
      price: "123",
      size: "321",
      xx: 1,
      yy: 1,
      isSold: "Open",
    });

    // this.pullFromDB();

  }


  isEditing = (record) => {
    return record.key === this.state.editingKey;
  };

  edit(key) {
    var tempB = this.state.data[key].isSold
    this.setState({ editingKey: key, tempStatus: tempB });
  }

  save(form, key) {
    if (navigator.onLine) {
      form.validateFields((error, row) => {
        if (error) {
          return;
        }
        // alert('old' + JSON.stringify(this.state.data[0]))

        const newData = [...this.state.data];
        const index = newData.findIndex(item => key === item.key);
        if (index > -1) {
          const item = newData[index];
          newData.splice(index, 1, {
            ...item,
            ...row,
          });
          // alert('new' + JSON.stringify(newData[0]))
          if (!/^-?\d*[.,]?\d{0,2}$/.test(newData[index].price)) {
            message.error('Numbers only. Decimal point is allowed.')
          } else {
            load('Updating..', 0)
            newData[index].isSold = this.state.tempStatus
            // this.state.sa = newData[index].isSold
            // this.state.ca = newData[index].customer

            try {
              db
                .collection("units")
                .doc(this.state.data[index].id).set({
                  projects: newData[index].projects,
                  unittype: newData[index].unittype,
                  lot: newData[index].lot,
                  unitno: newData[index].unitno,
                  size: newData[index].size,
                  price: newData[index].price,
                  customer: newData[index].customer,
                  yy: newData[index].yy,
                  xx: newData[index].xx,
                  date: newData[index].date,
                  isSold: newData[index].isSold,
                }, { merge: true })
                .then((value) => {
                  message.destroy()
                  success('Successfully updated [Price: ' + newData[index].price + '] [Customer: ' + newData[index].customer + '] [Status: ' + newData[index].isSold + ']'
                  );
                  this.setState({ data: newData, editingKey: '' });
                })
                .catch(function (error) {
                  // The document probably doesn't exist.
                  message.destroy()
                  message.error(error.message);
                });
            } catch (error) {
              message.destroy()
              message.error(error.message);
            }

            // this.setState({ data: newData, editingKey: '' });
          }
        } else {
          newData.push(row);
          this.setState({ data: newData, editingKey: '' });
        }
      });
    } else {
      message.error('Can\'t save, no internet connection.')
    }

  }

  cancel = () => {
    this.setState({ editingKey: '' });
  };

  render() {
    const components = {
      body: {
        row: EditableFormRow,
        cell: EditableCell,
      },
    };

    const columns = this.columns.map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: record => ({
          record,
          inputType: col.dataIndex === 'price' ? 'text' : 'text',
          dataIndex: col.dataIndex,
          title: col.title,
          editing: this.isEditing(record),
        }),
      };
    });
    return (
      <div>
        <h1>admin ({this.state.count} units)</h1>
        <br></br>
        {this.state.msglist}
        <Button onClick={this.exportFile}>Export to CSV</Button>
        <hr></hr>
        <h3>Import Units CSV Only</h3>
        <div><input type="file"
      accept="text/csv"
      onChange={this.handlefile}
    /><hr></hr><p>Use the export format, do not omit any columns.<br></br>Matching doc_id, it will update the fields, if not matching doc_id, it will create a new one with the correesponding fields.
    </p></div>

        <Table
          className='admintable'
          components={components}
          bordered
          dataSource={this.state.data}
          columns={columns}
          pagination={{ pageSize: 10 }}
          rowClassName="editable-row"
          scroll={{ x: 1500 }}
        />



      </div>
    )
  }
}
export default AdminUnits;



// WEBPACK FOOTER //
// ./src/tests/adminunits.js